/**
 * Obtiene los movimientos de una cuenta digital
 * @param {number} digitalAccountId - ID de la cuenta digital
 * @param {string} token - Token de autenticación
 * @returns {function} - Función que acepta parámetros de paginación y filtros
 */
export const getMovements = (digitalAccountId, token) => (payload = {}) => {
  const params = new URLSearchParams();
  
  if (payload.startDate) params.append('startDate', payload.startDate);
  if (payload.endDate) params.append('endDate', payload.endDate);
  if (payload.page) params.append('page', payload.page);
  if (payload.pageSize) params.append('pageSize', payload.pageSize || 50);

  return {
    endpoint: `/api/v1/movements/${digitalAccountId}?${params.toString()}`,
    method: 'GET',
    headers: {
      'x-authentication-token': token,
    },
    cache: false,
    force: payload?.force,
    proxy: false,
  };
};

/**
 * Descarga movimientos en formato CSV
 * @param {number} digitalAccountId - ID de la cuenta digital
 * @param {string} startDate - Fecha de inicio (YYYY-MM-DD)
 * @param {string} endDate - Fecha de fin (YYYY-MM-DD)
 * @param {string} token - Token de autenticación
 * @returns {object} - Configuración de la petición
 */
export const downloadMovementsCsv = (digitalAccountId, startDate, endDate, token) => {
  return {
    endpoint: `/api/v1/movements/${digitalAccountId}/download?startDate=${startDate}&endDate=${endDate}`,
    method: 'GET',
    headers: {
      'x-authentication-token': token,
    },
    responseType: 'blob',
    proxy: false,
  };
};

